export const passwordRecovery = {
  Back: 'Voltar',
  'In order to recover your password, please provide the CI used on your registration':
    'Para recuperar sua senha, por favor informe o CPF utilizado no seu cadastro',
  'Password Recovery': 'Recuperação de Senha',
  Continue: 'Continuar',
  "We've sent an email with instructions on how the recover your password Check your inbox":
    'Enviamos um email com as instruções de recuperação da senha. Verifique sua caixa de entrada',
};
